import { AlertTriangle, FileWarning, PackageX, Wallet } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type Problem = { Icon: LucideIcon; title: string; body: string };

const PROBLEMS: ReadonlyArray<Problem> = [
  {
    Icon: Wallet,
    title: 'La caisse qui ne tombe plus juste',
    body: "Un remboursement noté à la va-vite, et le tiroir-caisse ne correspond plus. Le soir, l'écart est inexplicable.",
  },
  {
    Icon: PackageX,
    title: "Le stock qui ment",
    body: "L'article revient mais n'est jamais remis en stock — ou l'est en double. Tes niveaux deviennent faux.",
  },
  {
    Icon: AlertTriangle,
    title: 'Le remboursement abusif',
    body: "Sans garde-fou, un caissier peut rembourser plus que la vente, ou plusieurs fois. Personne ne valide les gros montants.",
  },
  {
    Icon: FileWarning,
    title: 'Aucun historique',
    body: "Qui a remboursé quoi, quand, et pourquoi ? Sans trace, impossible de contrôler ni de contester un litige client.",
  },
];

export default function RetoursProblemV2() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <SectionLabel>Le vrai problème des retours</SectionLabel>
        <h2 className="mt-3 max-w-3xl font-marketing-display text-[clamp(30px,4.4vw,56px)] font-bold leading-[1.02] tracking-[-0.035em] text-charcoal-800">
          Un retour mal géré, <span className="underline-lime">c'est de l'argent perdu.</span>
        </h2>
        <p className="mt-4 max-w-xl font-marketing-body text-[17px] leading-[1.55] text-charcoal-600">
          Accepter un retour devrait rassurer le client — pas dérégler ta caisse et ton stock.
          Quatre risques reviennent toujours quand c'est fait à la main.
        </p>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {PROBLEMS.map(({ Icon, title, body }) => (
            <div
              key={title}
              className="flex flex-col gap-4 border-2 border-charcoal-800 bg-paper p-6 shadow-neobrutal-4"
            >
              <span className="flex h-12 w-12 items-center justify-center border-2 border-charcoal-800 bg-white text-terracotta-500 shadow-neobrutal-2">
                <Icon className="h-[22px] w-[22px]" strokeWidth={2} aria-hidden="true" />
              </span>
              <h3 className="font-marketing-display text-[19px] font-bold leading-[1.15] tracking-[-0.01em] text-charcoal-800">
                {title}
              </h3>
              <p className="font-marketing-body text-[14px] leading-[1.55] text-charcoal-600">
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
